"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoPlay = void 0;
const cash_dom_1 = __importDefault(require("cash-dom"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const plyr_1 = __importDefault(require("plyr"));
class VideoPlay {
    constructor(container) {
        // elements
        this.container = null;
        this.elements = null;
        this.video_modal = null;
        this.video_consent = null;
        this.video_container = null;
        this.video_icon = null;
        this.video_player = null;
        this.video_consent_info_template = null;
        this.video_consent_infos = [];
        this.show_video_consent = true;
        this.current_id = null;
        this.current_url = null;
        this.current_provider = null;
        this.current_image = null;
        this.indicator = null;
        this.container = container;
        this.video_modal = (0, cash_dom_1.default)('.fullscreen-video', container);
        this.video_consent = (0, cash_dom_1.default)('.video-consent', container);
        this.video_container = (0, cash_dom_1.default)('.video_player', container);
        this.video_consent_info_template = (0, cash_dom_1.default)('.video_consent_info_template', container).html();
        this.elements = (0, cash_dom_1.default)('.videoplay', container);
        this.indicator = (0, cash_dom_1.default)('.home-indicator', container);
        if (this.elements && this.elements.length > 0) {
            this.ini();
        }
    }
    ini() {
        // set click event
        this.elements.each((i, element) => {
            const video_id = (0, cash_dom_1.default)(element).attr('data-video-id');
            const video_url = (0, cash_dom_1.default)(element).attr('data-video-url');
            const video_provider = (0, cash_dom_1.default)(element).attr('data-video-provider');
            const video_image = (0, cash_dom_1.default)(element).attr('data-video-image');
            (0, cash_dom_1.default)(element).on('click', () => {
                this.current_id = video_id;
                this.current_url = video_url;
                this.current_provider = video_provider;
                this.current_image = video_image;
                this.showModal();
            });
            (0, cash_dom_1.default)(element).css({ cursor: 'pointer' });
        });
        /* $('.indicator', this.indicator).each( (i :Number, element :any) => {
     
           const video_id = $(element).attr('data-video-id');
           const video_url = $(element).attr('data-video-url');
           const video_provider = $(element).attr('data-video-provider');
           const video_image = $(element).attr('data-video-image');
           $(element).on('click', () => {
             console.log(video_id, video_provider)
     
             this.current_id = video_id;
             this.current_url = video_url;
             this.current_provider = video_provider;
             this.current_image = video_image;
             this.showModal();
     
           });
     
           $(element).css({cursor: 'pointer'} );
         });*/
    }
    showModal() {
        var _a, _b;
        this.show_video_consent = !js_cookie_1.default.get(`external-${this.current_provider}`) || ((_a = String(js_cookie_1.default.get(`external-${this.current_provider}`))) === null || _a === void 0 ? void 0 : _a.length) < 3 ? true : false;
        (0, cash_dom_1.default)('.image', this.video_container).css({ backgroundImage: `url(${this.current_image})` });
        if (this.show_video_consent) {
            (0, cash_dom_1.default)('.info', this.video_consent).html((_b = this.video_consent_infos[this.current_provider]) !== null && _b !== void 0 ? _b : this.getInfoText());
            (0, cash_dom_1.default)(this.video_consent).css({ backgroundImage: `url(${this.current_image})` });
            this.video_container.hide();
            this.video_consent.show();
            (0, cash_dom_1.default)('.accept', this.video_consent).on('click', () => {
                this.show_video_consent = false;
                js_cookie_1.default.set(`external-${this.current_provider}`, new Date().toJSON(), { expires: 120 });
                this.video_consent.hide();
                this.playVideo();
            });
        }
        else {
            this.playVideo();
        }
        this.video_modal.show();
        (0, cash_dom_1.default)('.top svg', this.video_modal).on('click', () => {
            var _a;
            (_a = this.video_player) === null || _a === void 0 ? void 0 : _a.pause();
            this.video_modal.hide();
        });
    }
    playVideo() {
        var _a;
        if (!this.video_player) {
            this.video_player = new plyr_1.default('#fullscreenvideohome');
        }
        (_a = this.video_player) === null || _a === void 0 ? void 0 : _a.setPreviewThumbnails(this.current_image);
        setTimeout(() => {
            var _a;
            if (this.video_player) {
                this.video_player.source = {
                    type: 'video',
                    sources: [
                        {
                            src: this.current_url,
                            provider: this.current_provider,
                        },
                    ],
                };
                this.video_consent.hide();
                this.video_container.show();
                (_a = this.video_player) === null || _a === void 0 ? void 0 : _a.play();
            }
        }, 1000);
    }
    getInfoText() {
        var _a, _b;
        let info = (_b = (_a = this.video_consent_info_template) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.replace('#PROVIDER#', this.current_provider.toUpperCase());
        this.video_consent_infos[this.current_provider] = info;
        return info;
    }
}
exports.VideoPlay = VideoPlay;
